<div class="rating-container">
  <ion-icon
    *ngFor="let i of starsArray"
    [name]="getStarIcon(i)"
    [class.interactive]="!readOnly"
    (click)="setRating(i, $event)"
  ></ion-icon>
</div>